module.exports = "../static/media/icon_mf_text.54776ca1.png";